/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["library-track-toggle-button{display:block;width:40px;height:40px;margin:0 auto;text-align:center}library-track-toggle-button .remove-button:hover .check-icon,library-track-toggle-button .remove-icon{display:none}library-track-toggle-button .remove-button:hover .remove-icon{display:inline-block}"];
export { styles as styles };
